import { gsap } from "gsap/all";

const countUp = (selector) => {

	if (!selector) return;

	const numbers = gsap.utils.toArray(selector);
	
	gsap.from(numbers, {
		innerText: 0,
		duration: 1,
		snap: {
			innerText: 1,
		}
	});
};

export default countUp;
